import { Component, Input } from "@angular/core";
import { DataIcon } from "./dataIcon";
import { DataValueStyle } from "./dataValueStyle";

@Component({
    selector: 'single-data',
    templateUrl: './singleData.component.html',
    standalone: false
})
export class SingleDataComponent {
    public dataIcon = DataIcon;
    public dataValueStyle = DataValueStyle;

    @Input() public icon: DataIcon = DataIcon.None;
    @Input() public value: number = 0;
    @Input() public valueStyle: DataValueStyle = DataValueStyle.None;
    @Input() public subValue: string;
    @Input() public footer: string;
    @Input() public footerStyle: DataValueStyle = DataValueStyle.None;
}